import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

const assessment = 'case';
const apiRoutes = {
	assessment: assessment,
	check_id: assessment + '/check-id',
	case_search: assessment + '/case-search',
	case_members: assessment + '/case-members',
	project_members: assessment + '/project-members',
	merge_chunks: assessment + '/sent-to-merge',
	re_invite: assessment + '/re-invite'
}

@Injectable({ providedIn: 'root' })
export class AssessmentService {
	private refreshAssessmentList = new Subject<void>();

	constructor(private http: HttpClient) { }

	refreshList() {
    this.refreshAssessmentList.next();
  }

	getRefreshObservable() {
    return this.refreshAssessmentList.asObservable();
  }

  getProjectMembers(project_id: number, params: any) {
    return this.http.get<any>(environment.api + apiRoutes.project_members + '/' + project_id, { params: params });
  }

  getProjectCaseMembers(project_id: number, case_id: number, params: any) {
    return this.http.get<any>(environment.api + apiRoutes.case_members + '/' + project_id + '/' + case_id, { params: params });
  }

  getProjectCaseMembershipForCurrentUser(project_id: number, case_id: number) {
    return this.http.get<any>(environment.api + apiRoutes.case_members + '/' + project_id + '/' + case_id);
  }

  addOrUpdateCaseMember(project_id: number, case_id: number, data: any) {
    return this.http.post<any>(environment.api + apiRoutes.case_members + '/' + project_id + '/' + case_id, data);
  }

  removeCaseMember(project_id: number, case_id: number, member_id: number) {
    return this.http.delete<any>(environment.api + apiRoutes.case_members + '/' + project_id + '/' + case_id + '/' + member_id);
  }

  createAssessment(project_id: number, data: any) {
    return this.http.post<any>(environment.api + apiRoutes.assessment + '/' + project_id, data);
  }

  updateAssessment(project_id: number, case_id: number, data: any) {
    return this.http.patch<any>(environment.api + apiRoutes.assessment + '/' + project_id + '/' + case_id, data);
  }

  deleteAssessment(project_id: number, case_id: number) {
    return this.http.delete<any>(environment.api + apiRoutes.assessment + '/' + project_id + '/' + case_id);
  }

	getProjectAssessments(project_id: number, params: any) {
		return this.http.get<any>(environment.api + apiRoutes.assessment + '/' + project_id, { params: params });
	}

  getProjectAssessment(project_id: number, case_id: number, params: any) {
    return this.http.get<any>(environment.api + apiRoutes.assessment + '/' + project_id + '/' + case_id, { params: params });
  }

  searchAssessmentsBySubjectId(project_id: number, params: any): Observable<any[]> {
    return this.http.get<any>(environment.api + apiRoutes.case_search + '/' + project_id, { params: params });
  }

  checkIdExists(project_id: number, idToCheck: string, originalId: string): Observable<boolean> {
    return this.http.post<any>(environment.api + apiRoutes.check_id + '/' + project_id, { id: idToCheck, exclude: originalId });
  }

  getProjectCaseActivity(project_id: number, case_id: number, activity_id: number, params: any): Observable<any> {
    return this.http.get<any>(environment.api + apiRoutes.assessment + '/' + project_id + '/' + case_id + '/' + activity_id, { params: params });
  }

  updateProjectCaseActivity(project_id: number, case_id: number, activity_id: number, params: any, data: any) {
    return this.http.patch<any>(environment.api + apiRoutes.assessment + '/' + project_id + '/' + case_id + '/' + activity_id, data, { params: params });
  }

  deleteProjectCaseActivity(project_id: number, case_id: number, activity_id: number, params: any) {
    return this.http.delete<any>(environment.api + apiRoutes.assessment + '/' + project_id + '/' + case_id + '/' + activity_id, { params: params });
  }

  reInviteExaminee(project_id: number, case_id: number, activity_id: number, params: any, data: any) {
    return this.http.patch<any>(environment.api + apiRoutes.re_invite + '/' + project_id + '/' + case_id + '/' + activity_id, data, { params: params });
  }
  
  mergeChunks(project_id: number, case_id: number, activity_id: number, params: any, data: any) {
    return this.http.post<any>(environment.api + apiRoutes.merge_chunks + '/' + project_id + '/' + case_id + '/' + activity_id, data, { params: params });
  }
}